'use client';

import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { Market } from 'components/genius-ui/organisms/header/types';
import useMarket from 'helpers/hooks/useMarket';
import { Store } from 'shared/types/cart/Cart';
import { sdk } from 'sdk';

const initialMarketState = {
  market: {} as Market,
  markets: [] as Market[],
  handleMarket: {} as (market: Market) => void,
  storeOptions: [] as Store[],
  selectedStore: undefined as string | undefined,
  changeSelectedStore: (storeKey: string) => {},
};

const MarketContext = createContext(initialMarketState);

const MarketProvider = ({ children }: React.PropsWithChildren) => {
  const [storeOptions, setStoreOptions] = useState<Store[]>([]);
  const [selectedStore, setSelectedStore] = useState<string | undefined>();
  const { market, markets, handleMarket } = useMarket();

  const getStoreOptions = useCallback(async () => {
    const response = await sdk.callAction({
      actionName: 'project/getStoreOptions',
    });
    return (response?.isError ? {} : response?.data) as { stores: Store[]; selectedStore: string };
  }, []);

  const changeSelectedStore = useCallback((storeKey: string) => {
    setSelectedStore(storeKey);
  }, []);

  useEffect(() => {
    getStoreOptions()
      .then((data) => {
        const validStores = data?.stores?.filter((store) => store.countries?.length) || [];
        setStoreOptions(validStores);
        let selectedStoreKey = data.selectedStore;
        if (!selectedStoreKey) {
          const [firstStore] = validStores;
          selectedStoreKey = firstStore.key;
        }
        setSelectedStore(selectedStoreKey);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return (
    <MarketContext.Provider
      value={{ market: market as Market, markets, handleMarket, storeOptions, selectedStore, changeSelectedStore }}
    >
      {children}
    </MarketContext.Provider>
  );
};

const useMarketList = () => useContext(MarketContext);

export { MarketContext, MarketProvider, useMarketList };
